export default __webpack_public_path__ + "static/media/MM PR Announcement Final 2013 02 12.87587fbc.pdf";